var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FxDapHttpErrorHandler } from './fx-http-error-handler';
import { DwSystemConfigService, DwUserService, DwHttpClient } from '@webdpt/framework';
import { ActivatedRoute } from '@angular/router';
import { map, tap } from 'rxjs/operators';
var DEFAULT_OPEN_MASK = false;
var FxDapHttpClient = /** @class */ (function (_super) {
    __extends(FxDapHttpClient, _super);
    function FxDapHttpClient(systemConfig, userService, dapHttpError, route) {
        var _this = _super.call(this) || this;
        _this.systemConfig = systemConfig;
        _this.userService = userService;
        _this.dapHttpError = dapHttpError;
        _this.route = route;
        // 根据当前网址判断是哪个数据库-不同数据库对应的api不一样
        var href = window.location.href;
        var apiUrl;
        // 区分数据库的环境还未搭建好，暂时先用不同的环境测试
        if (href.indexOf('eshop/') !== -1) { // 测试环境
            apiUrl = 'apiUrlOracle';
        }
        else if (href.indexOf('eshop2/') !== -1) { // 正式环境
            apiUrl = 'apiUrlMySQL';
        }
        else {
            apiUrl = 'apiUrl';
        }
        _this.systemConfig.get(apiUrl).subscribe(function (url) { return _this.api = url; });
        _this.systemConfig.get('apiUrl').subscribe(function (url) { return _this.api = url; });
        return _this;
    }
    Object.defineProperty(FxDapHttpClient.prototype, "defaultHeaders", {
        get: function () {
            var token = this.userService.getUser('token') ? this.userService.getUser('token') : '';
            // @ts-ignore
            // const programCode = this.route.snapshot._routerState.url.split(';')[0].replace('/dwTabRouting/', '');
            var programCode = '', url = this.route.snapshot._routerState.url; // program-code
            if (url.indexOf('sce') !== -1) {
                programCode = url.slice(url.indexOf('sce'), url.indexOf('sce') + 8); // 作业编号固定7位数
            }
            else if (url.indexOf('mall') !== -1) {
                programCode = 'scei001';
            }
            else {
                programCode = 'fxed020';
            }
            // return {
            //   'token': token
            // };
            // header 的值为：
            // defaultHeader + authService.userData
            var tokenTest = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ7XCJwcm9maWxlXCI6e1wiY19vYmpcIjpcImFkbWluXCIsXCJpc0ZpcnN0TG9naW5cIjpcIk5cIixcInByaW1lcktleVwiOlwicXV3alwiLFwiY19wZXJfbjFcIjpcImFkbWlu55So5oi3XCIsXCJjX3VzZXJcIjpcInF1d2pcIixcImNfZW50XCI6OTksXCJjX2xhbmNfbjFcIjpcIueugOS9k-S4reaWh1wiLFwiYWJqbXRlbFwiOlwiMTg2NTI5MTU2ODNcIixcImNfbGFuZ1wiOlwiemhfQ05cIixcImNfb3JnXCI6XCIxMDAwMDFcIixcImNfZGVwdFwiOlwiMTAwMDAxMDFcIixcImNfdXNlcl9uMVwiOlwi556_5paH5aifXCIsXCJjX3BlclwiOlwiYWRtaW5cIixcImNfb3JnX24xXCI6XCLmgLvpg6hcIn19IiwiaWF0IjoxNTc0OTk2MjYwLCJqdGkiOiI5ZTNjZDI2My00ODNmLTQxM2EtYjE4MC02MDhlZjNjZjMzZDIifQ._nIm6zU271psZVryF8jEX5Ye_WPFOOqeUKhcpDpFbjyG3_KQcwZqS0aiYErS1dbTLZ4LKyBdi08kGsoNPs02PA";
            return {
                'token': token ? token : tokenTest,
                'program-code': programCode,
            };
        },
        enumerable: true,
        configurable: true
    });
    FxDapHttpClient.prototype.responseIntercept = function (body) {
        if (body && body.response) {
            return body.response;
        }
        else {
            return body;
        }
    };
    FxDapHttpClient.prototype.errorHandler = function (event) {
        console.error(event);
        if (event.error && event.error.status) {
            this.dapHttpError.handlerError(event);
        }
    };
    FxDapHttpClient.prototype.post = function (url, body, options) {
        var needmask = (options || { mask: DEFAULT_OPEN_MASK }).mask;
        if (needmask === undefined) {
            needmask = DEFAULT_OPEN_MASK;
        }
        this.load.getMask('', needmask);
        var requestOptions = this.addDefaultOption(options);
        var request = this.http.post(this.api + url, body, requestOptions);
        return this.requestProcessWithMask(request, needmask);
    };
    FxDapHttpClient.prototype.requestProcessWithMask = function (request, needmask) {
        var _this = this;
        return request.pipe(tap(function (response) {
            _this.load.getMask('', needmask, true);
            return response;
        }, function (error) {
            _this.load.getMask('', needmask, true);
            _this.systemHttpError.handlerError(error);
            _this.errorHandler(error);
        }), map(function (response) { return _this.responseIntercept(response); }));
    };
    return FxDapHttpClient;
}(DwHttpClient));
export { FxDapHttpClient };
